/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



app.controller('EventCtrl', ['$scope', '$http', 'NetworkService', function ($scope, $http, NetworkService) {

        $scope.email = MaId;

        NetworkService.getParticipatedShifts($scope.email, function (data) {
            $scope.events = data
        })
        
        $scope.renderShiftTime = function(datetime)
        {
            var myDate = new mDate(datetime)
            var time = myDate.getTime()
            return time;
        }
    }])